export default __webpack_public_path__ + "static/media/logotipo-780.9034b283.png";